import script from "./courseStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./courseStatistics.vue?vue&type=script&setup=true&lang=js"

import "./courseStatistics.vue?vue&type=style&index=0&id=a31700d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a31700d8"]])

export default __exports__